<script setup lang="ts">
const props = defineProps<{
    trueValue?: string
    falseValue?: string
    modelValue?: any
    label?: string
    small?: boolean
}>()

const emit = defineEmits<{
    (_e: 'update:modelValue', _value?: any): void
}>()

const selected = computed({
    get() {
        return props.modelValue
    },
    set(value) {
        emit('update:modelValue', value)
    }
})

const options = computed(() => {
    return [
        {
            value: false,
            label: props.falseValue
        },
        {
            value: true,
            label: props.trueValue
        }
    ]
})
</script>

<template>
    <div class="flex flex-col">
        <UiLabel>
            {{ label }}
        </UiLabel>

        <div class="flex items-center gap-1">
            <UiButton
                v-for="(option, index) in options"
                :key="index"
                :small="small"
                :active="option.value === selected"
                @click="selected = option.value"
            >
                {{ option.label }}
            </UiButton>
        </div>
    </div>
</template>